import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f8f8dde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-root" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_3 = { class: "input-field user-name" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "input-field password" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "dp-value" }
const _hoisted_8 = {
  key: 0,
  class: "dp-list"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "input-field call"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "input-capcha-group" }
const _hoisted_13 = { class: "input-field shield-check" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "capcha-image-wrap" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "agree-info" }
const _hoisted_18 = { class: "button-group" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "dropdown-content" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_user = _resolveComponent("i-user")!
  const _component_i_lock = _resolveComponent("i-lock")!
  const _component_i_layer = _resolveComponent("i-layer")!
  const _component_i_arrow_l = _resolveComponent("i-arrow-l")!
  const _component_i_call = _resolveComponent("i-call")!
  const _component_i_sheild_check = _resolveComponent("i-sheild-check")!
  const _component_i_reload = _resolveComponent("i-reload")!
  const _component_icon_arrow_down = _resolveComponent("icon-arrow-down")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      action: "",
      class: "form",
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_i_user, {
          class: "icon",
          "start-color": '#854b97',
          "end-color": '#854b97'
        }),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uname) = $event)),
          placeholder: _ctx.t('login.username')
        }, null, 8, _hoisted_4), [
          [_vModelText, _ctx.uname]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_i_lock, {
          class: "icon",
          "start-color": '#854b97',
          "end-color": '#854b97'
        }),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pwd) = $event)),
          placeholder: _ctx.t('login.password')
        }, null, 8, _hoisted_6), [
          [_vModelText, _ctx.pwd]
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "input-field layer",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showLoginType = !_ctx.showLoginType), ["prevent"]))
      }, [
        _createVNode(_component_i_layer, {
          class: "icon",
          "start-color": '#854b97',
          "end-color": '#854b97'
        }),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t(`login.${_ctx.loginType.name}`)), 1),
        _createVNode(_component_i_arrow_l, {
          class: _normalizeClass(["icon-arrow-l", { active: _ctx.showLoginType }]),
          color: '#854b97'
        }, null, 8, ["class"]),
        _createVNode(_Transition, { name: "slide-down" }, {
          default: _withCtx(() => [
            (_ctx.showLoginType)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLoginType, (_loginType) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: _loginType.id,
                      onClick: ($event: any) => (_ctx.onSelectLoginType(_loginType))
                    }, _toDisplayString(_ctx.t(`login.${_loginType.name}`)), 9, _hoisted_9))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])), [
        [_directive_click_outside, _ctx.hideShowLoginType]
      ]),
      (_ctx.loginType.id === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_i_call, {
              class: "icon",
              "start-color": '#854b97',
              "end-color": '#854b97'
            }),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.phoneNumber) = $event)),
              placeholder: _ctx.t('login.enterphonenumber')
            }, null, 8, _hoisted_11), [
              [_vModelText, _ctx.phoneNumber]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_i_sheild_check, {
            class: "icon",
            "start-color": '#854b97',
            "end-color": '#854b97'
          }),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.capchaInput) = $event)),
            placeholder: _ctx.t('login.verificationcode'),
            onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onCapchaKeydown && _ctx.onCapchaKeydown(...args)))
          }, null, 40, _hoisted_14), [
            [_vModelText, _ctx.capchaInput]
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", { src: _ctx.capchaSrc }, null, 8, _hoisted_16)
          ]),
          _createVNode(_component_i_reload, {
            "start-color": '#854b97',
            "end-color": '#854b97',
            class: "reload",
            onClick: _ctx.getImage
          }, null, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", {
          class: _normalizeClass(["cirle-indicator", { 'active': _ctx.agreed }]),
          onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.agreed = !_ctx.agreed), ["prevent"]))
        }, null, 2),
        _createElementVNode("div", {
          class: "agree-info-label",
          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAgreeBox && _ctx.showAgreeBox(...args)), ["prevent"]))
        }, _toDisplayString(_ctx.t('login.useragreement')), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          type: "submit",
          class: "submit",
          disabled: !_ctx.agreed
        }, _toDisplayString(_ctx.t('login.login')), 9, _hoisted_19),
        _createElementVNode("button", {
          type: "button",
          class: "button",
          onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doTrylogin && _ctx.doTrylogin(...args)), ["prevent"]))
        }, _toDisplayString(_ctx.t('login.guestlogin')), 1)
      ])
    ], 32),
    _createElementVNode("div", {
      class: _normalizeClass(["lang-options", [_ctx.lang, { show: _ctx.showLanguageOptions }]]),
      onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.showLanguageOptions = !_ctx.showLanguageOptions), ["self"]))
    }, [
      _createTextVNode(_toDisplayString(_ctx.language) + " ", 1),
      _createVNode(_component_icon_arrow_down),
      _createElementVNode("ul", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langArr, (i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i.code,
            class: _normalizeClass([{ active: i.code === _ctx.lang }, i.code]),
            onClick: ($event: any) => (_ctx.selectLanguage(i.code))
          }, [
            _createTextVNode(_toDisplayString(i.name) + " ", 1),
            _hoisted_22
          ], 10, _hoisted_21))
        }), 128))
      ])
    ], 2)
  ]))
}